module.exports = __webpack_public_path__ + "img/gallery-3.ca53a1cb.jpg";